<script lang="ts">
import { useTranslation } from '@bluebrick/saas-ui'
import { defineComponent, toRefs } from 'vue'

export default defineComponent({
	props: {
		path: {
			type: String,
			required: true
		}
	},
	setup(props, { slots }) {
		const { t } = useTranslation()
		const { path } = toRefs(props)

		const regex = /(\[\[[^\]]+\]\])/g

		const translatedStringParts = t(path.value).split(regex)

		const nodes = translatedStringParts.map((el) => {
			if (regex.test(el)) {
				const slotName = el.substring(2, el.length - 2)

				if (slotName in slots && slots[`${slotName}`]) {
					return (slots[`${slotName}`] as () => unknown)()
				}
			}

			return el
		})

		return () => nodes
	}
})
</script>
